// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.claims.UpdateAdditionalClaimInformationRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateAdditionalClaimInformationRequest extends GandalfModelBase {

	@GandalfLabel('Alternate Service Location')
	@GandalfProperty({ designType: Number })
	alternateServiceLocationId!: number | null;

	@GandalfLabel('Attachment Control Number')
	@GandalfValidator({ sizeString: { message: 'Attachment Control Number cannot be longer than 80 characters', minLength: 0, maxLength: 80 } })
	@GandalfProperty({ designType: String })
	attachmentControlNumber!: string | null;

	@GandalfConstantDecorator(constants.ClaimAttachmentTransmission)
	@GandalfLabel('Attachment Transmission')
	@GandalfProperty({ designType: constants.ClaimAttachmentTransmission })
	attachmentTransmission!: constants.ClaimAttachmentTransmission | null;

	@GandalfConstantDecorator(constants.ClaimAttachmentType)
	@GandalfLabel('Attachment Type')
	@GandalfProperty({ designType: constants.ClaimAttachmentType })
	attachmentType!: constants.ClaimAttachmentType | null;

	@GandalfLabel('Authorization')
	@GandalfProperty({ designType: Number })
	authorizationId!: number | null;

	@GandalfConstantDecorator(constants.ClaimFrequencyCode)
	@GandalfLabel('Claim Frequency Code')
	@GandalfProperty({ designType: constants.ClaimFrequencyCode })
	claimFrequencyCode!: constants.ClaimFrequencyCode | null;

	@GandalfLabel('CLIA Number')
	@GandalfValidator({ sizeString: { message: 'CLIA Number cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	cliaNumber!: string | null;

	@GandalfConstantDecorator(constants.ClaimVisionConditionApply)
	@GandalfLabel('Condition Contacts Apply')
	@GandalfProperty({ designType: constants.ClaimVisionConditionApply })
	conditionContactsApply!: constants.ClaimVisionConditionApply | null;

	@GandalfLabel('Condition Contacts L1')
	@GandalfProperty({ designType: Boolean })
	conditionContactsL1!: boolean | null;

	@GandalfLabel('Condition Contacts L2')
	@GandalfProperty({ designType: Boolean })
	conditionContactsL2!: boolean | null;

	@GandalfLabel('Condition Contacts L3')
	@GandalfProperty({ designType: Boolean })
	conditionContactsL3!: boolean | null;

	@GandalfLabel('Condition Contacts L4')
	@GandalfProperty({ designType: Boolean })
	conditionContactsL4!: boolean | null;

	@GandalfLabel('Condition Contacts L5')
	@GandalfProperty({ designType: Boolean })
	conditionContactsL5!: boolean | null;

	@GandalfConstantDecorator(constants.ClaimVisionConditionApply)
	@GandalfLabel('Condition Frames Apply')
	@GandalfProperty({ designType: constants.ClaimVisionConditionApply })
	conditionFramesApply!: constants.ClaimVisionConditionApply | null;

	@GandalfLabel('Condition Frames L1')
	@GandalfProperty({ designType: Boolean })
	conditionFramesL1!: boolean | null;

	@GandalfLabel('Condition Frames L2')
	@GandalfProperty({ designType: Boolean })
	conditionFramesL2!: boolean | null;

	@GandalfLabel('Condition Frames L3')
	@GandalfProperty({ designType: Boolean })
	conditionFramesL3!: boolean | null;

	@GandalfLabel('Condition Frames L4')
	@GandalfProperty({ designType: Boolean })
	conditionFramesL4!: boolean | null;

	@GandalfLabel('Condition Frames L5')
	@GandalfProperty({ designType: Boolean })
	conditionFramesL5!: boolean | null;

	@GandalfConstantDecorator(constants.ClaimVisionConditionApply)
	@GandalfLabel('Condition Lenses Apply')
	@GandalfProperty({ designType: constants.ClaimVisionConditionApply })
	conditionLensesApply!: constants.ClaimVisionConditionApply | null;

	@GandalfLabel('Condition Lenses L1')
	@GandalfProperty({ designType: Boolean })
	conditionLensesL1!: boolean | null;

	@GandalfLabel('Condition Lenses L2')
	@GandalfProperty({ designType: Boolean })
	conditionLensesL2!: boolean | null;

	@GandalfLabel('Condition Lenses L3')
	@GandalfProperty({ designType: Boolean })
	conditionLensesL3!: boolean | null;

	@GandalfLabel('Condition Lenses L4')
	@GandalfProperty({ designType: Boolean })
	conditionLensesL4!: boolean | null;

	@GandalfLabel('Condition Lenses L5')
	@GandalfProperty({ designType: Boolean })
	conditionLensesL5!: boolean | null;

	@GandalfLabel('Current Illness Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	currentIllnessDate!: Date | null;

	@GandalfConstantDecorator(constants.ClaimCurrentIllnessDateQualifier)
	@GandalfLabel('Current Illness Date Qualifier')
	@GandalfProperty({ designType: constants.ClaimCurrentIllnessDateQualifier })
	currentIllnessDateQualifier!: constants.ClaimCurrentIllnessDateQualifier | null;

	@GandalfConstantDecorator(constants.CodeSet)
	@GandalfLabel('Diagnosis Code Set')
	@GandalfValidator({ notNull: { message: 'Diagnosis Code Set is required' } })
	@GandalfProperty({ designType: constants.CodeSet, isRequired: true })
	diagnosisCodeSet!: constants.CodeSet;

	@GandalfLabel('End Care Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	endCareDate!: Date | null;

	@GandalfConstantDecorator(constants.ClaimEpsdtApply)
	@GandalfLabel('EPSDT Apply')
	@GandalfProperty({ designType: constants.ClaimEpsdtApply })
	epsdtApply!: constants.ClaimEpsdtApply | null;

	@GandalfConstantDecorator(constants.ClaimEpsdtCode)
	@GandalfLabel('EPSDT Code 1')
	@GandalfProperty({ designType: constants.ClaimEpsdtCode })
	epsdtCode1!: constants.ClaimEpsdtCode | null;

	@GandalfConstantDecorator(constants.ClaimEpsdtCode)
	@GandalfLabel('EPSDT Code 2')
	@GandalfProperty({ designType: constants.ClaimEpsdtCode })
	epsdtCode2!: constants.ClaimEpsdtCode | null;

	@GandalfConstantDecorator(constants.ClaimEpsdtCode)
	@GandalfLabel('EPSDT Code 3')
	@GandalfProperty({ designType: constants.ClaimEpsdtCode })
	epsdtCode3!: constants.ClaimEpsdtCode | null;

	@GandalfLabel('Hospitalization End Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	hospitalizationEndDate!: Date | null;

	@GandalfLabel('Hospitalization Start Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	hospitalizationStartDate!: Date | null;

	@GandalfLabel('Additional Claim Information')
	@GandalfValidator({ notNull: { message: 'Additional Claim Information is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	id!: number;

	@GandalfLabel('Initial Treatment Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	initialTreatmentDate!: Date | null;

	@GandalfLabel('Local Use')
	@GandalfValidator({ sizeString: { message: 'Local Use cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	localUse!: string | null;

	@GandalfLabel('Claim Codes')
	@GandalfValidator({ sizeString: { message: 'Claim Codes cannot be longer than 20 characters', minLength: 0, maxLength: 20 } })
	@GandalfProperty({ designType: String })
	localUse10d!: string | null;

	@GandalfLabel('Medicaid Resubmit Code')
	@GandalfValidator({ sizeString: { message: 'Medicaid Resubmit Code cannot be longer than 20 characters', minLength: 0, maxLength: 20 } })
	@GandalfProperty({ designType: String })
	medicaidResubmitCode!: string | null;

	@GandalfLabel('Ordering Provider')
	@GandalfProperty({ designType: Number })
	orderingProviderId!: number | null;

	@GandalfLabel('Original Reference Number')
	@GandalfValidator({ sizeString: { message: 'Original Reference Number cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfProperty({ designType: String })
	originalReferenceNumber!: string | null;

	@GandalfLabel('Out of Work End Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	outOfWorkEndDate!: Date | null;

	@GandalfLabel('Out of Work Start Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	outOfWorkStartDate!: Date | null;

	@GandalfLabel('Outside Lab')
	@GandalfValidator({ notNull: { message: 'Outside Lab is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	outsideLab!: boolean;

	@GandalfLabel('Outside Lab Charges')
	@GandalfValidator({ notNull: { message: 'Outside Lab Charges is required' } })
	@GandalfProperty({ propertyType: 'Money', designType: Number, isRequired: true })
	outsideLabCharges!: number;

	@GandalfLabel('Prior Authorization Number')
	@GandalfValidator({ sizeString: { message: 'Prior Authorization Number cannot be longer than 40 characters', minLength: 0, maxLength: 40 } })
	@GandalfProperty({ designType: String })
	priorAuthorizationNumber!: string | null;

	@GandalfLabel('Referral Number')
	@GandalfValidator({ sizeString: { message: 'Referral Number cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfProperty({ designType: String })
	referralNumber!: string | null;

	@GandalfLabel('Referring Provider')
	@GandalfProperty({ designType: Number })
	referringProviderId!: number | null;

	@GandalfLabel('Person Insurance')
	@GandalfProperty({ designType: Number })
	secondaryPayerId!: number | null;

	@GandalfLabel('Signature Handwritten')
	@GandalfProperty({ designType: Boolean })
	signatureHandwritten!: boolean | null;

	@GandalfLabel('Similar Illness Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	similarIllnessDate!: Date | null;

	@GandalfConstantDecorator(constants.ClaimSimilarIllnessDateQualifier)
	@GandalfLabel('Similar Illness Date Qualifier')
	@GandalfProperty({ designType: constants.ClaimSimilarIllnessDateQualifier })
	similarIllnessDateQualifier!: constants.ClaimSimilarIllnessDateQualifier | null;

	@GandalfLabel('Start Care Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	startCareDate!: Date | null;

	@GandalfLabel('Version')
	@GandalfValidator({ notNull: { message: 'Version is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	version!: number;

	@GandalfLabel('Vision Prescription Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	visionPrescriptionDate!: Date | null;

}
